export interface ProductLookUpPriceProps {
  productPriceId: number;
  basePrice: number;
  startDate: string | null;
  endDate: string | null;
}

export class ProductLookUpPrice {
  private readonly _productPriceId: number;
  private readonly _basePrice: number;
  private readonly _startDate: string | null;
  private readonly _endDate: string | null;

  constructor(props: ProductLookUpPriceProps) {
    this._productPriceId = props.productPriceId;
    this._basePrice = props.basePrice;
    this._startDate = props.startDate;
    this._endDate = props.endDate;
  }

  public get productPriceId(): number {
    return this._productPriceId;
  }

  public get basePrice(): number {
    return this._basePrice;
  }

  public get startDate(): string | null {
    return this._startDate;
  }

  public get endDate(): string | null {
    return this._endDate;
  }
}
